module.exports = __webpack_public_path__ + "images/28c302e83b76ebb4f4ec956c41543f79.svg";